<ng-container *ngFor="let group of output">
    <drag-and-drop-group [displayProperty]="displayProperty" [items]="group.Items" [title]="group.Title">
    </drag-and-drop-group>
</ng-container>
